export default __webpack_public_path__ + "static/session-dont-dark-7b4699b26af8e0631fc75b01d6073db8.png";